import { UserAnalyticsMapper } from './UserAnalyticsMapper.js';

class UserAnalyticsRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getShipmentsOverTime(params) {
    return this.apiClient.get('v1/analytics/shipments/time', params).then(response => response.data);
  }
  getShipmentsOverTimeSerie(params) {
    return this.getShipmentsOverTime(params).then(data => UserAnalyticsMapper.createChartSerieFromResponse(data, 'shipmentsOverTime'));
  }
  getShippingCostOverTime(params) {
    return this.apiClient.get('v1/analytics/shipments/cost', params).then(response => response.data);
  }
  getShippingCostOverTimeSeries(params) {
    return this.getShippingCostOverTime(params).then(data => UserAnalyticsMapper.createCurrencySeriesFromResponse(data, 'shippingCostOverTime'));
  }
  getShipmentsByCarrier(params) {
    return this.apiClient.get('v1/analytics/shipments/carriers', params).then(response => response.data.map(UserAnalyticsMapper.createShipmentsByCarrierFromResponse));
  }
  getShipmentsByCountry(params) {
    return this.apiClient.get('v1/analytics/shipments/country', params).then(response => response.data);
  }
  getShipmentsByContent(params) {
    return this.apiClient.get('v1/analytics/shipments/content', params).then(response => response.data);
  }
}

export { UserAnalyticsRepository };
//# sourceMappingURL=UserAnalyticsRepository.js.map
